module.exports = __webpack_public_path__ + "img/slide_prev.30be6077.svg";